export const DefaultAvatar = './assets/img/default-avatar.png';

export const IconNotification = './assets/img/logo.png';

export const TimeZone = '-0300';
